import React, {useContext} from 'react';
import {observer} from "mobx-react";
import {useLoaderData, useNavigate} from "react-router-dom";
import * as Servicer from "../index";
import {ServicerPrepareAddFormResponse} from "../../../types/modules/servicer/response";
import {StoreContext} from "../../../store.context";

export const Add: React.FC = observer(() => {
    const { appStore: {
        moduleStore: { servicerStore: { add }},
    }} = useContext(StoreContext);

    const navigate = useNavigate();

    const data: ServicerPrepareAddFormResponse = useLoaderData() as ServicerPrepareAddFormResponse;

    const onCancel = () => {
        navigate(`/servicer`)
    }

    return <Servicer.Form onSave={add} onCancel={onCancel} preparedData={data} />
})